import React from 'react';
import ReactDOM from 'react-dom/client';

import '_sources/images/favicon-16x16.png';
import '_sources/images/favicon-32x32.png';

import App from './App';
import './styles/root.less';

const app = (): void => {
    /**
     * Render application
     */
    const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
    root.render(<App />);
};

if ((module as any).hot && __DEV__) {
    module.hot.accept('./App', app);
}

try {
    app();
} catch (err) {
    // Sentry.captureException(err);
}
